import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.asyncview = {
    init:function(element, va, bindings, model, context) {
        var view_model = ko.unwrap(bindings().async_model);
        if (ko.unwrap(view_model.paged)) {
            if (typeof view_model.page_size == "undefined")
                view_model.page_size = ko.observable(10);
            if (typeof view_model.start == "undefined")
                view_model.start = ko.observable(0);
            if (typeof view_model.total == "undefined")
                view_model.total = ko.observable(0);
        }
        $(element).bind("editable_list.select", function(ev,ui) {
            var view_model = ko.unwrap(bindings().async_model);
            $(element).data("editing-url", null);
            $(element).data("editing", true);
            var source_elt = ui;
            var entity = ko.unwrap(view_model.entity);
            var view = ko.unwrap(view_model.editor_view);
            if (Object.isObject(ui)) {
                if (ko.unwrap(ui.url))
                    url = ko.unwrap(ui.url);
                if (ko.unwrap(ui.entity))
                    entity = ko.unwrap(ui.entity);
                if (ko.unwrap(ui.view))
                    view = ko.unwrap(ui.view);
            }
            var polymorphic = ko.unwrap(view_model.polymorphic) !== false;
            var editable_data = ko.dataFor($(source_elt)[0]);
            if (polymorphic && editable_data.__entity__ && ko.unwrap(editable_data.__entity__))
                entity = ko.unwrap(editable_data.__entity__);
            var selected_id = ko.unwrap(editable_data.id);

            var url = Crimson.url.appendUrl(Crimson.root, entity, selected_id, view);
            Crimson.net.fetch(url, { "partial":true, "async_view":true }).done(function(result) {
                $(element).data("editing", true);
                try {
                    var new_url = result.__new_url;
                    if (typeof new_url != "undefined") {
                        $(element).data("editing-url", new_url);
                    }
                    $(element).data("original-url", url);

                    var page = Crimson.view.createPageModel(result, new_url, url);
                    page.currentUrl(new_url || url);
                    page.viewdata().__page__ = function() { return page; };
                    view_model.selected(page);
                    if (page.suspend)
                        page.suspend(false);

                    //result.data.__is_new = result.__is_new;
                    //result = Crimson.view.createViewModel(result);
                    //view_model.selected(result);
                }
                finally {
                    $(element).data("editing",false);
                }
            });
            return false;
        }).bind("editable_list.cancel", function(ev,source_elt) {
            var view_model = ko.unwrap(bindings().async_model);
            view_model.selected(null);
            return false;
        }).bind("editable_list.reload", function(ev,source_elt) {
            ko.bindingHandlers.asyncview.update(element, va, bindings, model, context);
        }).bind("editable_list.delete", function(ev,source_elt) {
            var view_model = ko.unwrap(bindings().async_model);
            var dead_item = ko.dataFor($(source_elt)[0]);
            var id = ko.unwrap(dead_item.id);
            if (id) {
                Crimson.net.delete_item(view_model.entity, id).done(function(result) {
                    $(element).trigger("editable_list.reload");
                });
            }
        }).bind("editable_list.add", function(ev,ui) {
            Crimson.net.save().done(function() {
                Crimson.view.reloadViews().done(function() {
                    var view_model = ko.unwrap(bindings().async_model);
                    var origin_data = ko.unwrap(va());

                    if (origin_data)
                        var oid = ko.unwrap(origin_data.__unique_id);

                    var url = null;
                    var entity = ko.unwrap(view_model.entity);
                    var view = ko.unwrap(view_model.editor_view);
                    if (Object.isObject(ui)) {
                        if (ko.unwrap(ui.url))
                            url = ko.unwrap(ui.url);
                        if (ko.unwrap(ui.entity))
                            entity = ko.unwrap(ui.entity);
                        if (ko.unwrap(ui.view))
                            view = ko.unwrap(ui.view);
                    }

                    url = url || Crimson.url.appendUrl(Crimson.url.appendUrl(Crimson.root, entity), view);
                    var p = {
                        "origin":oid,
                        "path":ko.unwrap(view_model.field),
                        "async_view":true,
                        "partial":true
                    };
                    Crimson.net.fetch(url, p).done(function(result) {
                        $(element).data("editing", true);
                        try {
                            var new_url = result.__new_url;
                            if (typeof new_url != "undefined") {
                                $(element).data("editing-url", new_url);
                            }
                            $(element).data("original-url", url);

                            var page = Crimson.view.createPageModel(result, new_url, url);
                            page.__initial_url = url;
                            page.currentUrl(new_url || url);
                            page.viewdata().__page__ = function() { return page; };
                            view_model.selected(page);
                            if (page.suspend)
                                page.suspend(false);

                            //result.data.__is_new = result.__is_new;
                            //result = Crimson.view.createViewModel(result);
                            //view_model.selected(result);
                        }
                        finally {
                            $(element).data("editing",false);
                        }
                    });
                });
            }).always(Crimson.view.hideLoader);

        }).bind("editable_list.save", function(ev,source_elt) {
            var view_model = ko.unwrap(bindings().async_model);
            var obj = view_model.selected();
            //var $list = $(element).closest(".asyncview").children(".async-list");
            var $list = $(element);

            //first make sure the ckeditors are blurred
            $list.parent().find("textarea.richtext").each(function() {
                console.l;
                var ck = $(this).data("ckeditor");
                if (ck) {
                    ck.fire("blur");
                }
            });

            var new_url = $list.data("editing-url");
            var original_url = $list.data("original-url");
            var url = Crimson.url.appendUrl(Crimson.url.appendUrl(Crimson.root, view_model.entity), view_model.editor_view);
            var origin_data = ko.unwrap(va());
            //we need the origin id
            var oid = null;
            if (origin_data)
                oid = ko.unwrap(origin_data.__unique_id);
            if (ko.unwrap(obj.id) && !obj.__is_new)
                url = Crimson.url.appendUrl(Crimson.url.appendUrl(Crimson.url.appendUrl(Crimson.root, view_model.entity), ko.unwrap(obj.id)), view_model.editor_view);
            var p = { "origin":oid, "path":view_model.field, "async_view":true, "partial":true, "data":ko.toJS(obj.model) };
            Crimson.net.submitForm(original_url || url,{"__json":ko.toJSON(p)}).done(function(result) {
                view_model.selected(null);
                Crimson.view.publish("view:try_save");
                //Crimson.rootModel().activePage().viewdata().__trigger_try_save();
                $(element).trigger("editable_list.reload");
            });
        });
        //Crimson.view.subscribe(element, "view:reload", function() { $(element).trigger("editable_list.reload"); });
        return {"controlsDescendantBindings":true };
    },
    update:function(element, va, bindings, model, context) {
        var view_model = ko.toJS(ko.unwrap(bindings().async_model));
        var origin_data = ko.unwrap(va());
        if ($(element).data("editing")) {
            return;
        }
        //we need the origin id
        if (origin_data)
            var oid = ko.unwrap(origin_data.__unique_id);
        if (!oid)
            oid = uly.utils.get_bound_entity(element) || uly.utils.get_bound_resource(element);
        if (!oid)
            if (context.$parent && context.$parent.unique_id)
                oid = context.$parent.unique_id;

        uly.api.start().follow("uly:dataviews").follow("find", {
            "rel":view_model.entity
        }).follow("find", {"rel":view_model.view}).then(function(result) {
            var view_res = HalResource(result);
            var d1 = view_res.follow("uly:markup", {"type":"html"});
            var d2 = view_res.follow("uly:results", {q:{
                "entity":view_model.entity,
                "origin":oid,
                "path":view_model.field,
                "offset":view_model.start||0,
                "max":25,
                "embed":true
            }});
            Promise.when(d1,d2).done(function([markup, result]) {
                if (view_model.paged) {
                    var start = result.offset;
                    var total =result.total;
                    var vm = ko.unwrap(bindings().async_model);
                    if (typeof vm.start == "function" && typeof vm.total == "function") {
                        $(element).data("editing",true);
                        try {
                            vm.start(start);
                            vm.total(total);
                        }
                        finally {
                            $(element).data("editing",false);
                        }
                    }
                }
                var $old_content = $(element).children("div.view");
                if ($old_content.length > 0)
                {
                    ko.cleanNode($old_content[0]);
                }
                $old_content.remove();
                var $content = $("<div></div>").addClass("view").appendTo($(element));
                $content.html(markup);
                var new_context = context.createChildContext(result.data);
                ko.applyBindings(new_context, $content[0]);
            });
        });
    }
};

ko.bindingHandlers.selectable = {
    init:function(element,va,bindings, model, bindingContext) {
        //TODO: Refactor this for more general solution to bubbling up selection
        var selection_obs = null;
        if (typeof bindingContext.selected_data == "function") {
            selection_obs = bindingContext.selected_data;
        } else if (typeof model.selected_data == "function") {
            selection_obs = model.selected_data;
        }
        else {
            var bc = bindingContext;
            while (bc.$parentContext) {
                bc = bc.$parentContext;
                if (typeof bc.$data.selected_data == "function") {
                    selection_obs = bc.$data.selected_data;
                    break;
                } else if (typeof bc.selected_data == "function") {
                    selection_obs = bc.selected_data;
                    break;
                }
            }
        }
        console.log("got selection obs:", selection_obs);

        if (selection_obs) {
            var $elt = $(element);
            $elt.click(function(ev,ui) {
                var value = ko.utils.unwrapObservable(va());
                if (selection_obs.indexOf(value) >= 0)
                {
                    selection_obs.remove(value);
                }
                else
                {
                    selection_obs.removeAll();
                    selection_obs.push(value);
                }
            });

            var subscription = selection_obs.subscribe(function(newvalue) {
                var value = ko.utils.unwrapObservable(va());
                if (newvalue && newvalue.indexOf(value) >= 0)
                    $elt.addClass("selected");
                else $elt.removeClass("selected");
            });

                            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                subscription.dispose();
                $elt.unbind("click");
                            });

        }
    }
};
